import { message, Divider, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";

import { controller } from "../TreatmentPlans/controller";

import search from "../../assets/icons/search-normal.svg";
// import calendar from "../../assets/icons/calendar.png";

export default function InsuranceBreakDownFilters({ allPatients, allProcedures, setFilterFormData, filterFormData }) {
  const [isFilteringProcedures, setIsFilteringProcedures] = useState(false);
  const [procedureSearch, setProcedureSearch] = useState("");
  const [dropdownProceduresOptions, setDropdownProceduressOptions] = useState([]);
  const [procedureSearchValue] = useDebounce(procedureSearch, 1000);

  const patientOptions = allPatients.map((patient) => ({
    value: patient.id,
    label: `${patient.first_name} ${patient.last_name}`,
  }));

  // const procedureOptions = allProcedures.map((procedure) => ({
  //   value: procedure.id,
  //   label: `${procedure.procedure_code} - ${procedure.name}`,
  // }));

  useEffect(function () {
    const procedureOptions = allProcedures.map((procedure) => ({
      value: procedure.id,
      label: `${procedure.procedure_code} ${procedure.procedure_code_description ? `- ${procedure.procedure_code_description}` : ""}`,
    }));

    setDropdownProceduressOptions(procedureOptions);
  }, []);

  const handleChangeProcedureSearch = async (input, option) => {
    setProcedureSearch(input); // Update the search input state
  };

  // Effect to handle debounced procedure search
  useEffect(() => {
    const fetchProcedures = async () => {
      let procedureCode = "";
      let procedureDescription = "";

      // Check if input is valid
      if (typeof procedureSearchValue !== "string" || !procedureSearchValue) {
        procedureDescription = procedureSearchValue || "";
      } else {
        // Extract numbers using regex
        const numberMatch = procedureSearchValue.match(/\d+/g);

        if (numberMatch) {
          // Join all number sequences for procedureCode
          procedureCode = numberMatch.join("");
          // Remove all numbers from input to get description
          procedureDescription = procedureSearchValue.replace(/\d+/g, "").trim();
          // Clean up any leading/trailing hyphens or spaces
          procedureDescription = procedureDescription.replace(/^-+|-+$/g, "").trim();
        } else {
          // If no numbers, entire input is description
          procedureDescription = procedureSearchValue.trim();
        }
      }

      try {
        setIsFilteringProcedures(true);
        const response = await controller.getProcedure(0, { procedureCode, procedureDescription });

        if (response.status < 250) {
          const data = await response.json;
          const procedureOptions = data.map((procedure) => ({
            value: procedure.id,
            label: `${procedure.procedure_code} ${procedure.procedure_code_description ? `- ${procedure.procedure_code_description}` : ""}`,
          }));

          setDropdownProceduressOptions(procedureOptions);
        }
      } catch (err) {
        message.error("Something went wrong while filtering procedures");
        console.error(err);
      } finally {
        setIsFilteringProcedures(false);
      }
    };

    fetchProcedures();
  }, [procedureSearchValue]);

  useEffect(
    function () {
      if (isFilteringProcedures) {
        setDropdownProceduressOptions([
          {
            value: "loading",
            label: <Spin />,
          },
        ]);
      }
    },
    [isFilteringProcedures]
  );

  return (
    <div style={{ width: "100%" }} className="insurance-filters-container">
      <p style={{ fontSize: 20 }}>Advanced Filters</p>

      <div className="insurance-filter-column">
        {/* Patient filter */}
        <div className="patient-treatment-insurance-estimate-inputs" style={{ width: "100%" }}>
          <label className="filter-inputs-label">Patient</label>

          <Select
            showSearch
            mode="multiple"
            placeholder="Search Patient"
            optionFilterProp="label"
            options={patientOptions}
            className={`breakdown-select-patient-id`}
            value={filterFormData.patient_ids || undefined}
            prefix={<img style={{ width: 20 }} src={search} alt="arrow-down" />}
            onChange={(value) => setFilterFormData((prevFilters) => ({ ...prevFilters, patient_ids: value }))}
          />
        </div>

        <Divider type="vertical" style={{ height: 65, marginTop: 10, backgroundColor: "#B7B7B7", marginInline: 30 }} />

        {/* Procedure Filter */}
        <div className="insurance-filter-column">
          {/* Patient filter */}
          <div className="patient-treatment-insurance-estimate-inputs" style={{ width: "100%" }}>
            <label className="filter-inputs-label">Procedure</label>

            <Select
              showSearch
              mode="multiple"
              placeholder="Search Procedure"
              optionFilterProp="label"
              options={dropdownProceduresOptions}
              className={`breakdown-select-patient-id`}
              filterOption={(input, option) => handleChangeProcedureSearch(input, option)}
              value={filterFormData.procedure_ids || undefined}
              prefix={<img style={{ width: 20 }} src={search} alt="arrow-down" />}
              onChange={(value) => setFilterFormData((prevFilters) => ({ ...prevFilters, procedure_ids: value }))}
            />
          </div>
        </div>

        {/* <Divider type="vertical" style={{ height: 65, marginTop: 10, backgroundColor: "#B7B7B7", marginInline: 30 }} /> */}

        {/* Expiry Date Filter */}
        {/* <div className="patient-treatment-insurance-estimate-inputs">
          <label className="filter-inputs-label">Expiry Date</label>

          <DatePicker
            onChange={(date, dateString) => setFilterFormData({ ...filterFormData, expiry_date: dateString })}
            suffixIcon={<img src={calendar} alt="" />}
            style={{ width: "90%", height: 42, border: "1px solid #6B43B5" }}
            format="YYYY-MM-DD"
            dateFormat="YYYY-MM-DD"
            className="insurance-filter-input"
          />
        </div> */}
      </div>
    </div>
  );
}
